module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "main-menu__submenu"
  }, [_c('li', {
    staticClass: "main-menu__item has-droprdown"
  }, [_c('a', {
    class: {
      'active': (_vm.activeLinks.indexOf(_vm.settingLink) + 1)
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.$root.toggleMenu($event)
      }
    }
  }, [_c('md-icon', {
    staticClass: "arrow-icon-right"
  }, [_vm._v("keyboard_arrow_right")]), _vm._v(" "), _c('md-icon', {
    staticClass: "arrow-icon-down"
  }, [_vm._v("keyboard_arrow_down")]), _vm._v(" "), _c('md-icon', [_vm._v("settings")]), _vm._v(" "), _c('span', [_vm._v("Настройки")])], 1), _vm._v(" "), _c('ul', {
    staticClass: "main-menu__submenu"
  }, _vm._l((_vm.settings), function(menu) {
    return (Object.keys(_vm.settings).length) ? _c(menu, {
      key: menu.name,
      tag: "component"
    }) : _vm._e()
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5377ba97","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/module/menus/MainMenu.vue
// module id = 1145
// module chunks = 0